<template>
  <svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 0.5H2C0.9 0.5 0.0100002 1.4 0.0100002 2.5L0 18.5C0 19.6 0.89 20.5 1.99 20.5H14C15.1 20.5 16 19.6 16 18.5V6.5L10 0.5ZM14 18.5H2V2.5H9V7.5H14V18.5ZM4 13.51L5.41 14.92L7 13.34V17.5H9V13.34L10.59 14.93L12 13.51L8.01 9.5L4 13.51Z"
      fill="#9CA3AF"
    />
  </svg>
</template>
